import React from 'react';
import PropTypes from 'prop-types';
import {
	Section,
	Container,
	Row,
	Column,
	H2,
	MarkdownWrapper,
} from 'components/atoms';
import './ContentSection.scss';

const ContentSection = ({ title, content, contentType, theme = 'white' }) => {
	const color = theme === 'dark' ? 'white' : '';

	return (
		<Section className={`content-section ${theme}`}>
			<Container>
				<Row>
					<Column medium={12}>
						<div className="content-section-container">
							<H2
								className="title"
								color={color}
							>
								{title}
							</H2>

							<Row className={`content ${contentType}`}>
								{content.map((item, index) => (
									<Column
										key={index}
										medium={12}
										large={
											contentType === 'row-type' ? 12 : 4
										}
										className={`content-column ${color}`}
									>
										<MarkdownWrapper
											content={[{ value: item }]}
											componentProps={{
												color,
												className: item?.includes(
													'https://',
												)
													? 'bright-link'
													: '',
											}}
										/>
									</Column>
								))}
							</Row>
						</div>
					</Column>
				</Row>
			</Container>
		</Section>
	);
};

ContentSection.propTypes = {
	title: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.string),
	contentType: PropTypes.string,
	theme: PropTypes.oneOf(['white', 'light-Blue']),
};

export default ContentSection;
